module.exports = __webpack_public_path__ + "static/img/loading.84b2c18b.gif";